import { Link } from 'react-router-dom';
import { BsHouse, BsPerson, BsSearch,BsBuilding } from 'react-icons/bs';
const Bottomnav = () => {
	const phone = localStorage.getItem('user-phone');
	const styling = {
		color: 'black',
		fontSize: '18px',
	};
	return (
		<div className="bottom-nav flex-evenly">
			{phone !== null && (
				<Link style={styling} to="/">
					<BsHouse />
				</Link>
			)}

			{phone !== null && (
				<Link style={styling} to="/Mybeats" onClick={(e) => localStorage.setItem('person-phone', phone)}>
					<BsPerson />
				</Link>
			)}
			{phone !== null && (
				<Link style={styling} to="/Search">
					<BsSearch />
				</Link>
			)}

			{phone !== null && (
				<Link style={styling} to="/Playhouse">
					<BsBuilding/>
				</Link>
			)}

			{phone === null && (
				<Link style={styling} to="/join">
					Join
				</Link>
			)}
		</div>
	);
};

export default Bottomnav;
